export default __webpack_public_path__ + "static/media/bg_astra.f75a3d0d.png";